<p-confirmDialog key="edit" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Options-->
<div class="MainGrid2Col">
	<label>School:</label>
	<label class="InfoText">{{ SchoolFullName }}</label>

	<label>Available Count:</label>
	<input [disabled]="Processing" class="form-control" type="number" min="0" [(ngModel)]="AvailableCount" (ngModelChange)="onAvailableCountChange($event)" />

	<label>Total Count:</label>
	<label class="InfoText">{{ TotalCount }}</label>
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="Processing" class="btn btn-primary" (click)="onUpdate()">Update</button>
	<button [disabled]="Processing" class="btn btn-warning LeftMargin" (click)="onClose()">Close</button>
</div>
